import React from "react";

import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Grid,
  SxProps,
  Typography,
} from "@mui/material";

import { SolutionsFrame } from "components/solutions/SolutionsFrame";
import { SOLUTIONS_DATA } from "./SolutionsHomeData";

const SX_STYLE: SxProps = {
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: 2,
};

export const SolutionsHome = ({ history }) => {
  return (
    <SolutionsFrame>
      <Typography variant="h2" component="h1" sx={{ mt: 2, mb: 2 }}>
        Indique como quer iniciar ou acelerar sua jornada de descarbonização
        energética:
      </Typography>
      <Grid item container direction="column" sx={SX_STYLE}>
        {SOLUTIONS_DATA.map(({ title, imgSrc, imgAlt, linkTo }) => (
          <Card key={title[0]}>
            <CardActionArea
              disabled={!linkTo}
              onClick={() => history.push(linkTo)}
            >
              <CardMedia sx={{ display: "flex", justifyContent: "center" }}>
                <img alt={imgAlt} src={imgSrc} height="120" />
              </CardMedia>
              <CardContent>
                {title.map((line) => (
                  <Typography variant="body2" align="center">
                    {line}
                  </Typography>
                ))}
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Grid>
    </SolutionsFrame>
  );
};
